import {
  QUERY_KEYS,
  soCaiColumns,
  thanhToanPhaiThuColumns,
  thanhToanPhaiTraColumns,
  thueVatDauVaoColumns
} from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

const tableItems: InfoTableItem[] = [
  {
    title: 'Xem sổ cái',
    endpoint: QUERY_KEYS.SO_CAI,
    columns: soCaiColumns,
    group: 1
  },
  {
    title: 'Thanh toán phải thu',
    endpoint: QUERY_KEYS.THANH_TOAN_PHAI_THU,
    columns: thanhToanPhaiThuColumns,
    group: 1
  },
  {
    title: 'Thanh toán phải trả',
    endpoint: QUERY_KEYS.THANH_TOAN_PHAI_TRA,
    columns: thanhToanPhaiTraColumns,
    group: 1
  },
  {
    title: 'Thuế VAT đầu vào',
    endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO,
    columns: thueVatDauVaoColumns,
    group: 1
  }
];

const GiayBaoNoInfoDropdown = ({ uuid, ma_ct }: { uuid: string; ma_ct?: string }) => (
  <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} />
);

export default GiayBaoNoInfoDropdown;
